import { render, staticRenderFns } from "./taskWatchers.vue?vue&type=template&id=3ac9654f&"
import script from "./taskWatchers.vue?vue&type=script&lang=js&"
export * from "./taskWatchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports